import { create } from 'zustand';
import { User } from '../types/user';
import { authApi } from '../lib/apiClient';
import { broadcastLogout } from '../lib/authChannel';

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  loading: boolean;
  setUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  fetchCurrentUser: () => Promise<void>;
  login: (email: string, password: string) => Promise<any>;
  loginWithOAuth: (email: string, password: string, sessionId?: string) => Promise<any>;
  logout: () => Promise<any>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  loading: true,
  setUser: (user) => set({ user, isAuthenticated: !!user }),
  setLoading: (loading) => set({ loading }),
  fetchCurrentUser: async () => {
    try {
      const response = await authApi.getCurrentUser();
      set({ user: response, isAuthenticated: !!response, loading: false });
    } catch (error: any) {
      const status = error?.status;
      if (status === 401 || status === 403) {
        set({ user: null, isAuthenticated: false, loading: false });
        return;
      }
      set((state) => ({ ...state, loading: false }));
    }
  },
  login: async (email, password) => {
    const response = await authApi.login(email, password);
    set({ user: response.user, isAuthenticated: !!response.user, loading: false });
    return response;
  },
  loginWithOAuth: async (email, password, sessionId) => {
    const response = await authApi.clientLogin(email, password, sessionId);
    return response;
  },
  logout: async () => {
    set({ user: null, isAuthenticated: false, loading: false });
    broadcastLogout();
    const response = await authApi.logout();
    return response;
  },
}));
